import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { BreadcrumbComponent } from '@app/shared/breadcrumb/breadcrumb.component';
import { BlankComponent } from '@app/shared/layouts/blank/blank.component';
import { FullComponent } from '@app/shared/layouts/full/full.component';
import { SpinnerComponent } from '@app/shared/spinner.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormErrorWrapperComponent } from '@app/shared/form-error-wrapper/form-error-wrapper.component';
import { NavigationComponent } from '@shared/header-navigation/navigation.component';
import { SidebarComponent } from '@shared/sidebar/sidebar.component';

import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { PERFECT_SCROLLBAR_CONFIG } from 'ngx-perfect-scrollbar';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { CardUserComponent } from './card-user/card-user.component';
import { InputComponent } from './input/input.component';
import { CardCursoComponent } from './card-curso/card-curso.component';
import { CardGrupoComponent } from './card-grupo/card-grupo.component';
import { WebsiteComponent } from '@shared/layouts';
import { HasPermissionDirective } from './directives/has.permission.directive';
import { ImagenPipe } from './pipes/imagen.pipe';
import { MakePdfComponent } from './make-pdf/make-pdf.component';

import { TarifaFormsComponent } from './components/tarifa-forms/tarifa-forms.component';
import { ButtonLoaderComponent } from '@shared/components/button-loader';
import { CarouselComponent } from '@shared/components/carousel/carousel.component';
import { LoaderInlineComponent } from '@shared/components/loader-inline/loader-inline.component';
import { SwitchComponent } from '@shared/components/switch/switch.component';
import { HuespedFormsComponent } from './components/huesped-forms/huesped-forms.component';
import { ClientFormsComponent } from './components/client-forms/client-forms.component';

import { TooltipModule } from 'ng2-tooltip-directive';
import { CardRoomComponent } from '@shared/components/card-room/card-room.component';
import { PagosCalculateComponent } from './components/pagos-calculate/pagos-calculate.component';
import { ButtonComponent } from './components/button/button.component';
import { ServiceFormsComponent } from './components/service-forms/service-forms.component';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true,
  wheelSpeed: 1,
  wheelPropagation: true,
  minScrollbarLength: 20
};

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    NgbModule,
    ReactiveFormsModule,
    PerfectScrollbarModule,
    TooltipModule,
    NgMultiSelectDropDownModule
  ],
  declarations: [
    SpinnerComponent,
    BreadcrumbComponent,
    BlankComponent,
    FullComponent,
    ButtonLoaderComponent,
    FormErrorWrapperComponent,
    NavigationComponent,
    SidebarComponent,
    CarouselComponent,
    CardUserComponent,
    InputComponent,
    CardCursoComponent,
    CardGrupoComponent,
    WebsiteComponent,
    HasPermissionDirective,
    LoaderInlineComponent,
    ImagenPipe,
    SwitchComponent,
    MakePdfComponent,
    CardRoomComponent,
    TarifaFormsComponent,
    HuespedFormsComponent,
    ClientFormsComponent,
    PagosCalculateComponent,
    ButtonComponent,
    ServiceFormsComponent
  ],
  exports: [
    SpinnerComponent,
    BreadcrumbComponent,
    BlankComponent,
    FullComponent,
    ButtonLoaderComponent,
    FormErrorWrapperComponent,
    NavigationComponent,
    SidebarComponent,
    FormErrorWrapperComponent,
    CardUserComponent,
    InputComponent,
    CardCursoComponent,
    CardGrupoComponent,
    HasPermissionDirective,
    ImagenPipe,
    SwitchComponent,
    CardRoomComponent,
    TarifaFormsComponent,
    HuespedFormsComponent,
    ClientFormsComponent,
    PagosCalculateComponent,
    ButtonComponent,
    ServiceFormsComponent
  ],
  entryComponents: [MakePdfComponent, CarouselComponent],
  providers: [
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
    }
  ]
})
export class SharedModule {}
